import { gql } from '@apollo/client';
import { LocaleCode, LOCALE_BY_CODE } from '../../../../../utils/Locale';
import { queryWithFallbackKey } from '../../../common/tools/queryWithFallbackKey';

export const GET_NAVIGATION_NODE_LISTING_QUERY = queryWithFallbackKey(
    gql`
        query getNavigationNodeListing($defaultLanguage: String!) {
            getNavigationNodeListing(defaultLanguage: $defaultLanguage) {
                edges {
                    node {
                        id
                        key
                        index
                        fullpath
                        name
                        route
                        parentNode {
                            ... on object_NavigationNode {
                                id
                            }
                        }
                        isGlobalMenuItem
                        additionalMenuItemsSource
                    }
                }
            }
        }
    `,
    'GET_NAVIGATION_NODE_LISTING_QUERY'
);

export function getNavigationNodeListingQueryVariables(localeCode: LocaleCode) {
    return {
        defaultLanguage: LOCALE_BY_CODE[localeCode].pimcoreCode,
    };
}
